<template>
  <div>
    <legend>
      <span class="create-program-step-bubble">{{stepNumber}}</span>
      <span class="create-program-legend-title">{{stepTitle}}</span>
      <information-outline-icon
          class="clickable align-text-super"
          title="informationIconTitle"
          :size="20"
          fillColor="#EF7720" 
          @click="showContentPage(contentPage)"
        />
    </legend>
    <v-dialog />
  </div>
  
</template>
<script>
  import './style.scss';
  import { InformationOutlineIcon  } from '../../icons.js';
  
  export default {
    props: {
      
      stepNumber: {
        type: Number,
        required: true
      },
      
      stepTitle: {
        type: String,
        required: true
      },
      
      informationIconTitle: {
        type: String,
        default: 'Help'
      },
      
      contentPage: {
        type: String,
        required: true
      },
      
      infoId: {
        type: String
      }
    },
    data () {
      return {}
    },

    methods: {
      
      showContentPage (page) {
        return axios(`/pages/${page}`).then((result) => {
          this.$modal.show({
            name: 'delete_order_modal',
            template: `<section class="co-content-modal">
              <div class="co-modal-closebtn" @click="close">
                <span id="info_popup_close" class="close">X</span>
              </div>
              <div>${result.data}</div>
              </section>`,
            props: ['close']
          },{
            close: () => this.$modal.hide('delete_order_modal')
          },{
            width: 650,
            height: 'auto',
            adaptive: true,
            scrollable: true,
            name: 'delete_order_modal',
            styles: {
              'overflow-y': 'auto'
            }
          });
        });
      }
    },


    components: {
      InformationOutlineIcon,
    },
  }
</script>
